import type { Transaction } from 'prosemirror-state';

export class ProsemirrorInsertTextManager {
	constructor(
		private interimTextFrom: number | null = null,
		private interimTextTo: number | null = null,
	) {}

	insertText(transcript: string, tr: Transaction) {
		if (!transcript) {
			return tr;
		}

		const { selection } = tr;
		let pos = selection.$head.pos;

		// set the initial position of the interim text aand cache it
		if (this.interimTextFrom === null) {
			this.interimTextFrom = pos;
		} else {
			pos = this.interimTextFrom;
		}

		if (this.interimTextFrom && this.interimTextTo) {
			tr.delete(this.interimTextFrom, this.interimTextTo);
		}

		tr.insertText(transcript, pos);
		this.interimTextTo = pos + transcript.length;

		return tr;
	}

	rejectTranscriptedText(tr: Transaction) {
		const from = this.interimTextFrom;
		const to = this.interimTextTo;

		if (!from || !to) {
			return tr;
		}

		tr.delete(from, to);
		this.disposeTranscriptedText();

		return tr;
	}

	disposeTranscriptedText(): void {
		this.interimTextFrom = null;
		this.interimTextTo = null;
	}
}
